import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import { useNavigate } from 'react-router';
import { getPreviewOrderErrorType, PreviewOrderErrorType } from 'src/utils/previewOrderErrorUtils';
import { Link } from 'src/common/styled';
import { ErrorBar } from './ErrorBar';
import { usePageContext } from 'src/hooks';
/**
 * Helper function to convert the payment type into a camel case string that matches a locale key
 * e.g. GIFT_CARD -> payWithGiftCard
 */
export const getPaymentTypeKey = (paymentType) => {
    const titleCaseString = paymentType
        .toLowerCase()
        .replace(/(_\w)/g, (match) => match.toUpperCase().replace('_', ''))
        .replace(/^./, (match) => match.toUpperCase());
    return `payingWith${titleCaseString}`;
};
export const PaymentDetails = ({ errorReason, paymentMethod }) => {
    const { bundle } = usePageContext();
    const navigate = useNavigate();
    const onPaymentMethodChange = () => {
        navigate(`/checkout/payment-selection${location.search}`);
    };
    return (_jsxs(Row, { spacingInset: "400 350", spacing: "300", alignmentVertical: "stretch", "data-testid": "payment-selection-block", children: [(errorReason === null || errorReason === void 0 ? void 0 : errorReason.code) && getPreviewOrderErrorType(errorReason.code) === PreviewOrderErrorType.PAYMENT_METHOD && (_jsx(ErrorBar, { "data-testid": "error-bar" })), _jsxs(Column, { spacingInset: "none", spacing: "300", children: [_jsx(Text, { type: "h200", "data-testid": "paying-with-line", children: errorReason || paymentMethod == null
                            ? bundle.getMessage('payment')
                            : bundle.formatMessage(getPaymentTypeKey(paymentMethod.type), {
                                data: paymentMethod.tail,
                            }) }), _jsx(Text, { type: "b200", children: _jsx(Link, { role: "button", onClick: onPaymentMethodChange, "data-testid": "change-payment-method", children: bundle.getMessage('changePaymentMethod') }) })] })] }));
};
